import React, { useContext } from 'react'
import Box from '@mui/material/Box'
import Button from '@mui/material/Button'
import Tooltip from '@mui/material/Tooltip'
import RocketLaunchIcon from '@mui/icons-material/RocketLaunch'
import { GlobalContext, TenantSettingsContext } from '../../App'
import { openSignup } from './demoSignupUrl'

// Compact conversion button shown next to DemoSwitchButton in the header for
// demo tenants. Deliberately calmer than the pulsing switch pill — a plain
// contained success button — so it reads as "become a customer" rather than
// competing for the switch button's attention. Renders null unless
// tenantInfo?.isDemo, mirroring DemoSwitchButton, so it can only ever appear
// in demo context even if mounted elsewhere.
const DemoSignUpButton = ({ tenantInfo: tenantInfoProp, sx = {} }) => {
  const tenantSettings = useContext(TenantSettingsContext)
  const globalContext = useContext(GlobalContext)

  const tenantInfo =
    tenantInfoProp ?? tenantSettings?.tenantInfo ?? globalContext?.tenantInfo
  if (!tenantInfo?.isDemo) return null

  return (
    <Tooltip title="Create your own AmbuNet account">
      <Button
        variant="contained"
        color="success"
        size="small"
        disableElevation
        startIcon={<RocketLaunchIcon />}
        onClick={openSignup}
        sx={{
          borderRadius: 999,
          textTransform: 'none',
          fontWeight: 800,
          whiteSpace: 'nowrap',
          minWidth: 0,
          px: { xs: 1.25, sm: 2 },
          // Icon-only below the sm breakpoint, matching DemoSwitchButton.
          '& .MuiButton-startIcon': { ml: 0, mr: { xs: 0, sm: 1 } },
          ...sx,
        }}
      >
        <Box component="span" sx={{ display: { xs: 'none', sm: 'inline' } }}>
          Sign Up
        </Box>
      </Button>
    </Tooltip>
  )
}

export default DemoSignUpButton
